import { render } from "./Faq.vue?vue&type=template&id=48f2d9bb&scoped=true"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"

import "@/assets/css/style_parts.css?vue&type=style&index=0&id=48f2d9bb&lang=css&scoped=true"
import "@/assets/css/style_ranking.css?vue&type=style&index=1&id=48f2d9bb&lang=css&scoped=true"
import "@/assets/css/style_select.css?vue&type=style&index=2&id=48f2d9bb&lang=css&scoped=true"
import "./Faq.vue?vue&type=style&index=3&id=48f2d9bb&scoped=true&lang=css"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f2d9bb"]])

export default __exports__